type PrioritisedChangeItemProps = {
   title: string
   value: string | number
}

const PrioritisedChangeItem = ({
   title,
   value,
}: PrioritisedChangeItemProps) => {
   return (
      <div>
         <div className="log-card__title">{title}</div>
         <div>{value}</div>
      </div>
   )
}

export default PrioritisedChangeItem
